<template>
  <QDialog v-model="isOpen" @hide="afterLeave">
    <QCard>
      <div class="modal">
        <div class="modal__header">
          <h2 class="modal__title">Подтвердите действие</h2>
          <iconClose class="link gray-btn" @click="close()" />
        </div>
        <div class="modal__field narrow">
          <p class="modal__field--text"><slot></slot></p>
        </div>

        <div class="modal__field">
          <div class="modal__field--action row">
            <button class="btn-link" @click="close()">Нет</button>
            <button class="btn btn-primary" @click="submit()">Да</button>
          </div>
        </div>
      </div>
    </QCard>
  </QDialog>
</template>

<script lang="ts">
interface IState {
  preloader: boolean;
}

import { defineComponent, ref, reactive, PropType } from 'vue';
import iconClose from '@/components/icons/iconClose.vue';
import { QDialog, QCard, QInput, QCheckbox, QSelect } from 'quasar';
import iconCopy from '@/components/icons/iconCopy.vue';
import iconDelete from '@/components/icons/iconDelete.vue';

export default defineComponent({
  name: 'DeleteModal',
  components: {
    iconClose,
    QDialog,
    QCard,
    QInput,
    QCheckbox,
    QSelect,
    iconCopy,
    iconDelete,
  },
  emits: ['close', 'reset', 'submit'],
  props: {
    dataProps: {
      type: Object as PropType<Object | null>,
      default: null,
    },
  },

  setup(props, { emit }) {
    const isOpen = ref(false);
    const state: IState = reactive({
      preloader: false,
    });

    const submit = () => {
      isOpen.value = false;
      emit('submit', props.dataProps);
    };

    const close = () => {
      isOpen.value = false;
      emit('reset');
    };

    const afterLeave = () => {
      emit('close');
    };

    const reset = (): void => {
      emit('reset');
    };

    return {
      isOpen,
      close,
      afterLeave,
      reset,
      state,
      submit,
    };
  },
});
</script>

<style lang="scss" scoped>
.modal {
  max-width: 480px;
  padding: 48px;
  display: flex;
  flex-direction: column;
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__title {
    font-weight: 700;
    font-size: 23px;
    line-height: 28px;
    letter-spacing: 1px;
    color: var(--typography-blue);
  }
  &__label {
    margin-top: 20px;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 600;
    line-height: 17px;
    color: var(--typography-1);
  }
  &__field {
    position: relative;
    margin-top: 24px;
    min-width: 384px;
    &--action {
      gap: 16px;
      justify-content: flex-end;
    }
    &--text {
      color: var(--typography-blue);
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
    }
  }
}
</style>
